import * as styles from "@clientFrontend/features/scout/components/UserTable/styles.css";
import { Fragment } from "react";
import { LIST_MAX_LENGTH } from "@clientFrontend/features/scout/components/UserTable/constants";

type Props = {
  header: string;
  workNames: string[];
  tableRowClassName?: string;
};

export const WorksInfo = (props: Props) => {
  const { header, workNames, tableRowClassName } = props;

  return (
    <tr>
      <td colSpan={6} className={`${styles.td} ${styles.fullColTr} ${tableRowClassName ?? ""}`}>
        <div className={styles.fullColTrContent}>
          <b>{header}</b>
          <br />
          {workNames.slice(0, LIST_MAX_LENGTH).map((workName, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Fragment key={index}>
              {workName}
              <br />
            </Fragment>
          ))}
          {workNames.length > LIST_MAX_LENGTH && `他${workNames.length - LIST_MAX_LENGTH}求人`}
        </div>
      </td>
    </tr>
  );
};
